export default {
    'errors.notAuthenticated':
        'You are not authorized to perform this operation.',
    'errors.forbidden': 'You do not have permission to perform this operation',
    'errors.somethingWentWrong':
        'Something went wrong. Please reload the page or contact Binosight.',
};
